import { render, staticRenderFns } from "./HostingWhmPackages.vue?vue&type=template&id=08f172c0&"
import script from "./HostingWhmPackages.vue?vue&type=script&lang=js&"
export * from "./HostingWhmPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08f172c0')) {
      api.createRecord('08f172c0', component.options)
    } else {
      api.reload('08f172c0', component.options)
    }
    module.hot.accept("./HostingWhmPackages.vue?vue&type=template&id=08f172c0&", function () {
      api.rerender('08f172c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/reseller/HostingWhmPackages.vue"
export default component.exports